import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup, Col, Row } from 'reactstrap';
import { EInputMask } from 'src/Components/EInput';
import { UserStore } from 'src/Stores/User/UserStore';
import { IUser } from '../../../../Interfaces/UserInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminUsers extends React.Component {
    private mask = new EInputMask();
    public props: any;
    public usersList: any[] = [];
    public usersDisposer: any;
    public adminStore: any;
    public dataService: any = new DataService();
    public formattedUserList: IList;
    public UserStore: UserStore;

    public state = {
        formattedUserList: this.formattedUserList,
        typeFilters: ['Active', 'Inactive'] as string[],
        usersList: this.usersList,
    };

    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Status', 'class': 'align-left' },
        { content: 'Email', 'class': 'align-left' },
        { content: 'Phone Number', 'class': 'align-left' },
        { content: 'Location', 'class': 'align-left' },
        { content: 'Roles', 'class': 'align-left' }
    ];

    constructor(props: any) {
        super(props);
        this.adminStore = this.props.stores.AdminStore;
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.createDisposers();

        this.adminStore.getUsers();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    private createDisposers() {
        this.usersDisposer = intercept(this.adminStore, 'usersList', (change: any) => {
            this.setState({
                usersList: change.newValue
            }   );

            this.formatDataTable();

            return change;
        });
    }

    private clearDisposers() {
        this.usersDisposer();
    }

    public renderUserName(user: IUser) {
        return(
            <Link to={'/admin/users/' + user.email}>{user.firstName} {user.lastName}</Link>
        );
    }

    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.usersList.filter(this.filterList).map((user: IUser, index: number) => {
            const roles = user.roles || [];

            const row = [
                {
                    'class': 'align-left',
                    content: this.renderUserName.bind(this, user),
                    sortItem: `${user.firstName} ${user.lastName}`,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: user.status
                },
                {
                    'class': 'align-left',
                    content: user.email
                },
                {
                    'class': 'align-left',
                    content: this.mask.phone(user.phoneNumber),
                },
                {
                    'class': 'align-left',
                    content: user.location
                },
                {
                    'class': 'align-left',
                    content: roles.toString()
                }
            ];
            formattedData.push(row);
        });

        return { headers: this.tableHeaders, rows: formattedData };
    }

    public handleFilterBoxClick = (filterName: string) => (event: any) => {
        const filterIndex = this.state.typeFilters.findIndex((value: any) => value === filterName);
        let listFilters: any[] = this.state.typeFilters;
        if (filterName === 'all') {
            listFilters = [];
        } else if (filterIndex < 0) {
            listFilters.push(filterName);
        } else {
            listFilters.splice(filterIndex, 1);
        }
        this.setState({typeFilters: listFilters});
    }


    public buttonColor = (buttonName: string) => {
        const currList: any[] = this.state.typeFilters;
        if (currList.some(value => value === buttonName)) {
            return 'primary';
        }
        return 'outline-primary';
    }

    public allButtonTypeColor = () => {
        if (this.state.typeFilters.length > 0) {
            return 'outline-primary';
        }
        return 'primary';
    }

    public filterList = (item: IUser) => {
        let resultType;
        if (this.state.typeFilters.length === 0) {
            resultType = true;
        } else {

            for (const filterName of this.state.typeFilters)
            {
                if (item.status === filterName) {
                    resultType = true;
                }
            }
        }
        return resultType === true;
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="3">
                        <h1 className="float-left">Users</h1>
                    </Col>
                    <Col md="3">
                        <Button type='button' color={this.allButtonTypeColor()} onClick={this.handleFilterBoxClick('all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('Active')} onClick={this.handleFilterBoxClick('Active')}>Active</Button>
                            <Button type='button' color={this.buttonColor('Inactive')} onClick={this.handleFilterBoxClick('Inactive')}>Inactive</Button>
                        </ButtonGroup>
                    </Col>
                    <Col md="6">
                        {
                            this.UserStore.hasPermission('Permissions.Admin.Users.Create') &&
                            <Link to="/admin/users/new">
                                <Button color="primary" className="float-right">
                                    Add New User
                                </Button>
                            </Link>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable list={this.formatDataTable()} />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminUsers;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Users/AdminUsers.tsx